module.exports = __webpack_public_path__ + "2dda57416f52f193c953edd0598f7390.svg";